import { useMemo } from "react";
import { resetPasswordForm } from "../resetPasswordFormSetup.js";
import { useTexts } from "./useTexts.js";
const validationID = "INTERNAL_password_mismatch";
const emptyArray = [];
function useResetPasswordValidation(mode, validationSummaryItems = emptyArray) {
  const texts = useTexts();
  resetPasswordForm.useAddFieldValidation(
    "repeatPassword",
    (_field, formApi) => {
      const { newPassword, repeatPassword } = formApi.getValues();
      return repeatPassword !== newPassword;
    },
    {
      message: texts.passwordMismatchError,
      priority: 900,
      disabled: mode === "single-password",
      customUID: validationID,
      validationTrigger: "form"
    }
  );
  return useMemo(() => {
    switch (mode) {
      case "single-password":
        return validationSummaryItems;
      case "repeat-password":
        return [
          ...validationSummaryItems,
          {
            ids: [validationID],
            field: "repeatPassword",
            message: texts.passwordMismatchError
          }
        ];
    }
  }, [texts.passwordMismatchError, mode, validationSummaryItems]);
}
export {
  useResetPasswordValidation
};
//# sourceMappingURL=useResetPasswordValidation.js.map
